import React, { FC, MouseEventHandler } from 'react';
import Tag from './Tag';

interface props {
  port: number;
  onclick: MouseEventHandler<HTMLElement>;
}
interface PortMap {
  [key: number]: string;
}

export const COMMON_NETWORK_PORTS: PortMap = {
  22: 'SSH',
  80: 'HTTP',
  443: 'HTTPS',
  8080: 'HTTPS',
  5000: 'HTTPS',
};

const NetworkPortTag: FC<props> = ({ port, onclick }) => {
  const protocol = COMMON_NETWORK_PORTS[port];
  const display = protocol ? `${port}` : port;
  const tagColor = protocol ? 'blue' : 'bussy';
  const cursor = protocol ? 'cursor-pointer' : 'cursor-not-allowed';

  return (
    <div onClick={onclick} className={`${cursor}`}>
      <Tag style={tagColor} label={display} />
    </div>
  );
};

export default NetworkPortTag;
